import { http, HttpResponse } from 'msw'

export const mockDeactivatePolicy = http.put(
  '/my-business/api/agency/v1/*/:companyAlphaId/policies/:policyAlphaId/deactivate',
  async () => {
    return HttpResponse.json(null, { status: 200 })
  },
)
